<template>
  <svg fill="none" viewBox="0 0 16 17" xmlns="http://www.w3.org/2000/svg">
    <g fill="currentColor" clip-rule="evenodd" fill-rule="evenodd">
      <path
        d="M5.196 5.695c.26-.26.682-.26.943 0L8 7.557l1.861-1.862a.667.667 0 1 1 .943.943L8.943 8.5l1.862 1.862a.667.667 0 0 1-.943.943L8 9.443l-1.862 1.862a.667.667 0 1 1-.943-.943L7.058 8.5 5.196 6.638a.667.667 0 0 1 0-.943Z"
      />
      <path
        d="M8 14.5a6 6 0 1 1 0-12 6 6 0 0 1 0 12Zm-7.333-6a7.333 7.333 0 1 0 14.666 0 7.333 7.333 0 0 0-14.666 0Z"
      />
    </g>
  </svg>
</template>
